/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./task-center-list.vue?vue&type=template&id=364ef59a&scoped=true&"
import script from "./task-center-list.vue?vue&type=script&lang=ts&"
export * from "./task-center-list.vue?vue&type=script&lang=ts&"
import style0 from "./task-center-list.vue?vue&type=style&index=0&id=364ef59a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364ef59a",
  null
  
)

export default component.exports